export default "__VITE_ASSET__PS6uCLoU__"